import { Render } from "@measured/puck"
import { Button } from "antd"
import Spin from "antd/es/spin"
import AOS from "aos"
import "aos/dist/aos.css"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { t } from "../../../languages/i18n"
import "../config/styles.css"
import { newRenderConfig } from "../config/uiBuilderConfig"
import { useUiBuilder } from "../services/ui-builder"

export function Preview() {
  const { fetchBlockContent } = useUiBuilder()
  const { id } = useParams<{ id: string }>()
  const [data, setData] = useState<unknown>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchBlockContent(id!)

        const content = response.data.attributes.content ? JSON.parse(response.data.attributes.content) : null

        setData(content)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    fetchData()
    AOS.init()
  }, [])

  if (!data) {
    return <Spin />
  }

  return (
    <>
      <nav
        style={{
          backgroundColor: "white",
          padding: "10px",
          borderBottom: "1px solid #ddd",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          textAlign: "right",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button className="uppercase text-xs font-bold" onClick={() => (window.location.href = `/`)}>
          {t("Back to Home")}
        </Button>
        <Button
          type="primary"
          className="uppercase text-xs font-bold"
          onClick={() => (window.location.href = `/ui-builder/${id}`)}
        >
          {t("Edit with UI Builder")}
        </Button>
      </nav>
      <Render config={newRenderConfig} data={data} />
    </>
  )
}
